import fetchRetry from "fetch-retry";
const fetchWithRetry = fetchRetry(fetch);

export default async function (query, options = {}, signal = null) {
  if (query.length < 3) {
    return [];
  }

  try {
    const response = await fetchWithRetry(`/api/locations?q=${query}`, {
      cache: "force-cache",
      signal,
    }).catch((error) => {
      // Preserve AbortError so it can be properly handled upstream
      if (error.name === "AbortError") {
        throw error;
      }

      throw new Error("Could not connect to the Roomies API.", {
        cause: error,
      });
    });

    if (!response.ok) {
      throw new Error("Did not receive a response from the Roomies API.");
    }

    const json = await response.json();

    return json.data;
  } catch (error) {
    if (error.name === "AbortError") {
      throw error;
    }

    throw new Error("Could not load results from the Roomies API.", {
      cause: error,
    });
  }
}
